import * as React from 'react';

export type LayoutContextType = {
  hasLayoutBlockParent: boolean;
  layout: NordicNest.Api.NNLayout | null;
  gap?: any;
  index?: number;
  maxContentWidth: Excite.ContentApi.ContentWidth | string;
  contentWidthInPx?: number;
  mobileLayout?: NordicNest.Api.NNMobileLayout;
};

const LayoutContext = React.createContext<LayoutContextType>({
  hasLayoutBlockParent: false,
  layout: null,
  index: 0,
  maxContentWidth: 'full',
  contentWidthInPx: 0,
});

export function LayoutProvider({ children, ...props }: React.PropsWithChildren<LayoutContextType>) {
  return <LayoutContext.Provider value={props}>{children}</LayoutContext.Provider>;
}

export function useLayout() {
  return React.useContext(LayoutContext);
}
